import {
  CLICK_HISTORY_TAB_MERCHANTS_GET_FAILURE, CLICK_HISTORY_TAB_MERCHANTS_GET_SUCCESS,
} from '../actions/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const merchants = (state = initialState, action) => {
  switch (action.type) {
    case CLICK_HISTORY_TAB_MERCHANTS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload.response,
      };
    }
    case CLICK_HISTORY_TAB_MERCHANTS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: [],
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === CLICK_HISTORY_TAB_MERCHANTS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};

export default merchants;
